import React from 'react'
import { Link } from "gatsby"
import Arrow from "./icons/arrow"

export default function Cta({ props, to, arrow = false, className = "", format, canStretch = false, children, ...rest }) {
    const url = props?.url || to
    const target = props?.target
    const title = props?.title
    return (
        <>
            {url && (title || children || canStretch) ? <>
                {target !== "_blank" && (url?.startsWith("/") || url?.startsWith("#")) ?
                    <Link {...rest} to={url} target={target} className={`${className ? className : title ? "btn-text group" : ""} ${!title && !children && canStretch ? "link-stretched" : ""}`} aria-label={title || children || url}>
                        {title && <span dangerouslySetInnerHTML={{
                            __html: title,
                        }} />} {title && arrow ? <Arrow /> : null}
                        {children}
                    </Link>
                    :
                    <a {...rest} href={url} target={"_blank"} className={`${className ? className : title ? "btn-text group" : ""} ${!title && !children && canStretch ? "link-stretched" : ""}`} aria-label={`${title || children || url} (opens in a new tab)`} rel={`noreferrer`}>
                        {title && <span dangerouslySetInnerHTML={{
                            __html: title,
                        }} />} {title && arrow ? <Arrow /> : null}
                        {children}
                    </a>}
            </> : null
            }
        </>
    )
}

